export const categories = [
  { id: 'all', name: '全部', slug: 'all', description: '浏览全部韩国漫画作品' },
  { id: 'romance', name: '恋爱', slug: 'romance', description: '甜蜜浪漫的韩国恋爱漫画' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', description: '奇幻世界冒险韩漫' },
  { id: 'action', name: '动作', slug: 'action', description: '热血激战动作韩漫' },
  { id: 'drama', name: '剧情', slug: 'drama', description: '深度剧情韩漫作品' },
  { id: 'thriller', name: '悬疑', slug: 'thriller', description: '扣人心弦的悬疑韩漫' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', description: '爆笑欢乐韩国漫画' },
  { id: 'horror', name: '恐怖', slug: 'horror', description: '惊悚恐怖韩漫作品' },
  { id: 'slice-of-life', name: '日常', slug: 'slice-of-life', description: '温馨日常韩漫故事' },
];

export const comics = [
  {
    id: '1',
    slug: 'goddess-descends',
    title: '女神降临',
    author: '喵喵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20style%20beautiful%20female%20lead%20with%20makeup%20transformation%20soft%20pastel%20colors%20romantic%20atmosphere%20clean%20white%20background%20digital%20art%20illustration&width=600&height=800&seq=comic-01&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '校园', '逆袭'],
    status: '连载中',
    description: '因为外貌而自卑的女孩通过化妆技巧实现华丽变身，在校园中展开一段关于美丽、自信与爱情的成长故事。画风精美细腻，角色塑造深入人心，是近年来最受欢迎的韩国恋爱漫画之一。',
    updateDate: '2026-08-04',
    views: 1520000,
    rating: 9.5,
    chapters: [
      { num: 1, title: '第1话 平凡的我', date: '2025-01-15' },
      { num: 2, title: '第2话 改变', date: '2025-01-22' },
      { num: 3, title: '第3话 新学期的开始', date: '2025-01-29' },
      { num: 4, title: '第4话 初次见面', date: '2025-02-05' },
      { num: 5, title: '第5话 秘密', date: '2025-02-12' },
      { num: 6, title: '第6话 化妆的力量', date: '2025-02-19' },
      { num: 7, title: '第7话 心动的瞬间', date: '2025-02-26' },
      { num: 8, title: '第8话 误会', date: '2025-03-05' },
      { num: 9, title: '第9话 坦白', date: '2025-03-12' },
      { num: 10, title: '第10话 新的开始', date: '2025-03-19' },
      { num: 11, title: '第11话 竞争对手', date: '2025-03-26' },
      { num: 12, title: '第12话 真心', date: '2025-04-02' },
    ],
  },
  {
    id: '2',
    slug: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20style%20dark%20fantasy%20male%20warrior%20with%20sword%20standing%20in%20dungeon%20portal%20dramatic%20lighting%20epic%20atmosphere%20clean%20dark%20background%20digital%20art&width=600&height=800&seq=comic-02&orientation=portrait',
    category: 'action',
    tags: ['动作', '奇幻', '升级'],
    status: '连载中',
    description: '人类世界突然出现连接异次元的"门"，一部分人觉醒了特殊能力成为"猎人"。最弱E级猎人成振宇在一次双重地下城任务中濒死，却意外获得了可以无限升级的"系统"。从此踏上成为最强猎人的传奇之路。',
    updateDate: '2026-08-03',
    views: 3250000,
    rating: 9.8,
    chapters: [
      { num: 1, title: '第1话 最弱的猎人', date: '2024-06-10' },
      { num: 2, title: '第2话 双重地下城', date: '2024-06-17' },
      { num: 3, title: '第3话 系统的选择', date: '2024-06-24' },
      { num: 4, title: '第4话 每日任务', date: '2024-07-01' },
      { num: 5, title: '第5话 实力提升', date: '2024-07-08' },
      { num: 6, title: '第6话 第一次突袭', date: '2024-07-15' },
      { num: 7, title: '第7话 觉醒', date: '2024-07-22' },
      { num: 8, title: '第8话 秘密暴露', date: '2024-07-29' },
      { num: 9, title: '第9话 S级猎人的邀请', date: '2024-08-05' },
      { num: 10, title: '第10话 济州岛突袭', date: '2024-08-12' },
    ],
  },
  {
    id: '3',
    slug: 'tower-of-god',
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20style%20mysterious%20boy%20climbing%20giant%20tower%20colorful%20magical%20energy%20ethereal%20atmosphere%20clean%20white%20background%20digital%20art%20illustration&width=600&height=800&seq=comic-03&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '友情'],
    status: '连载中',
    description: '只要登顶神之塔，就能实现任何愿望。为了追寻唯一的朋友蕾哈尔，少年第二十五夜打开了塔的大门。在这座充满神秘与危险的巨塔中，每层都有不同的考验等待着挑战者。宏大的世界观和深刻的角色刻画让这部作品成为韩国奇幻漫画的里程碑。',
    updateDate: '2026-08-02',
    views: 2100000,
    rating: 9.6,
    chapters: [
      { num: 1, title: '第1话 塔的入口', date: '2024-01-10' },
      { num: 2, title: '第2话 第一层试炼', date: '2024-01-17' },
      { num: 3, title: '第3话 王冠游戏', date: '2024-01-24' },
      { num: 4, title: '第4话 队友', date: '2024-01-31' },
      { num: 5, title: '第5话 阴谋', date: '2024-02-07' },
      { num: 6, title: '第6话 第二层', date: '2024-02-14' },
      { num: 7, title: '第7话 管理者', date: '2024-02-21' },
      { num: 8, title: '第8话 蕾哈尔的真面目', date: '2024-02-28' },
    ],
  },
  {
    id: '4',
    slug: 'secret-class',
    title: '秘密教学',
    author: 'Yunki',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20cover%20style%20young%20man%20and%20woman%20close%20together%20intimate%20atmosphere%20warm%20lighting%20subtle%20tension%20clean%20soft%20background%20digital%20art&width=600&height=800&seq=comic-04&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '都市', '秘密'],
    status: '连载中',
    description: '刚步入职场的新人李贤宇，意外发现自己的直属上司竟是大学时期暗恋的学姐。工作中保持距离的两人，私下却展开了一段秘密的"教学"关系。禁忌的办公室恋情让两人在理智与情感之间不断挣扎。',
    updateDate: '2026-08-04',
    views: 980000,
    rating: 9.2,
    chapters: [
      { num: 1, title: '第1话 新员工', date: '2025-03-01' },
      { num: 2, title: '第2话 上司的真面目', date: '2025-03-08' },
      { num: 3, title: '第3话 第一次加班', date: '2025-03-15' },
      { num: 4, title: '第4话 深夜的办公室', date: '2025-03-22' },
      { num: 5, title: '第5话 周末偶遇', date: '2025-03-29' },
      { num: 6, title: '第6话 越界', date: '2025-04-05' },
      { num: 7, title: '第7话 同事的怀疑', date: '2025-04-12' },
      { num: 8, title: '第8话 地下恋情', date: '2025-04-19' },
    ],
  },
  {
    id: '5',
    slug: 'lookism',
    title: '外貌至上主义',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20style%20two%20faces%20of%20one%20person%20one%20handsome%20one%20ugly%20split%20composition%20dramatic%20contrast%20school%20uniform%20clean%20white%20background%20digital%20art&width=600&height=800&seq=comic-05&orientation=portrait',
    category: 'drama',
    tags: ['剧情', '校园', '社会'],
    status: '连载中',
    description: '胖墩高中生朴亨锡因遭受校园霸凌而转学到首尔，却意外发现自己拥有了两副身体——白天是完美帅气的男神，夜晚则回到自己原本的模样。通过两副截然不同的外表，他深刻体会到了这个"看脸"社会的残酷与现实。',
    updateDate: '2026-08-01',
    views: 2750000,
    rating: 9.4,
    chapters: [
      { num: 1, title: '第1话 转学', date: '2024-03-01' },
      { num: 2, title: '第2话 两个身体', date: '2024-03-08' },
      { num: 3, title: '第3话 新学校的日常', date: '2024-03-15' },
      { num: 4, title: '第4话 受欢迎的感觉', date: '2024-03-22' },
      { num: 5, title: '第5话 霸凌者的过去', date: '2024-03-29' },
      { num: 6, title: '第6话 朋友', date: '2024-04-05' },
    ],
  },
  {
    id: '6',
    slug: 'bastard',
    title: '甜蜜的家',
    author: '金坎比',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20horror%20cover%20style%20apartment%20building%20with%20monsters%20outside%20dark%20eerie%20atmosphere%20survival%20theme%20dim%20lighting%20clean%20dark%20background%20digital%20art&width=600&height=800&seq=comic-06&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '恐怖', '生存'],
    status: '已完结',
    description: '车贤秀在失去家人后搬进了一栋破旧的公寓楼，打算结束自己的生命。然而末日突然降临——人们开始变异成可怕的怪物。在这座与外界隔绝的公寓中，幸存者们必须团结一心，在绝望中寻找生存的希望。紧张刺激的生存恐怖故事。',
    updateDate: '2026-07-28',
    views: 1850000,
    rating: 9.7,
    chapters: [
      { num: 1, title: '第1话 新家', date: '2023-09-01' },
      { num: 2, title: '第2话 邻居们', date: '2023-09-08' },
      { num: 3, title: '第3话 第一声尖叫', date: '2023-09-15' },
      { num: 4, title: '第4话 封锁', date: '2023-09-22' },
      { num: 5, title: '第5话 怪物', date: '2023-09-29' },
      { num: 6, title: '第6话 幸存者会议', date: '2023-10-06' },
      { num: 7, title: '第7话 内部分裂', date: '2023-10-13' },
      { num: 8, title: '第8话 最后的希望', date: '2023-10-20' },
      { num: 9, title: '第9话 突围', date: '2023-10-27' },
      { num: 10, title: '第10话 结局', date: '2023-11-03' },
    ],
  },
  {
    id: '7',
    slug: 'eleceed',
    title: '超能觉醒',
    author: '孙齐皓',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comedy%20cover%20style%20young%20boy%20with%20electric%20powers%20and%20a%20fat%20cat%20beside%20him%20dynamic%20pose%20bright%20colors%20clean%20white%20background%20digital%20art&width=600&height=800&seq=comic-07&orientation=portrait',
    category: 'action',
    tags: ['动作', '超能力', '搞笑'],
    status: '连载中',
    description: '拥有超快速度能力的少年金志雄，在一次意外中救下了一只神秘的胖猫。没想到这只猫竟是世界最强超能力者之一！从此金志雄踏入了隐藏在现代社会中的超能力世界，结识了一群性格各异的超能力伙伴，展开热血又搞笑的冒险。',
    updateDate: '2026-08-03',
    views: 1680000,
    rating: 9.5,
    chapters: [
      { num: 1, title: '第1话 速度少年', date: '2024-08-01' },
      { num: 2, title: '第2话 神秘的猫', date: '2024-08-08' },
      { num: 3, title: '第3话 觉醒', date: '2024-08-15' },
      { num: 4, title: '第4话 组织', date: '2024-08-22' },
      { num: 5, title: '第5话 第一次任务', date: '2024-08-29' },
      { num: 6, title: '第6话 新伙伴', date: '2024-09-05' },
    ],
  },
  {
    id: '8',
    slug: 'magic-emporer',
    title: '魔道至尊',
    author: 'Wookjakga',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20martial%20arts%20cover%20style%20man%20in%20traditional%20black%20robe%20with%20dark%20energy%20surrounding%20him%20cultivation%20theme%20mysterious%20atmosphere%20clean%20dark%20gray%20background%20digital%20art&width=600&height=800&seq=comic-08&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '武侠', '重生'],
    status: '连载中',
    description: '一代魔道至尊陈长空在渡劫失败后，灵魂穿越回到少年时代。带着前世的所有记忆和战斗经验，他决心这一世不再重蹈覆辙，要在残酷的修真世界中走出一条属于自己的至尊之路。重生的魔尊，将以全新的姿态君临天下。',
    updateDate: '2026-08-02',
    views: 1350000,
    rating: 9.3,
    chapters: [
      { num: 1, title: '第1话 渡劫失败', date: '2024-11-01' },
      { num: 2, title: '第2话 重返少年', date: '2024-11-08' },
      { num: 3, title: '第3话 家族的耻辱', date: '2024-11-15' },
      { num: 4, title: '第4话 隐藏实力', date: '2024-11-22' },
      { num: 5, title: '第5话 家族大比', date: '2024-11-29' },
      { num: 6, title: '第6话 一战成名', date: '2024-12-06' },
    ],
  },
  {
    id: '9',
    slug: 'office-romance',
    title: '社内恋爱',
    author: 'Han Yura',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20romance%20cover%20style%20office%20workers%20man%20and%20woman%20sharing%20coffee%20playful%20expression%20bright%20office%20setting%20light%20and%20cheerful%20clean%20white%20background%20digital%20art&width=600&height=800&seq=comic-09&orientation=portrait',
    category: 'comedy',
    tags: ['搞笑', '恋爱', '职场'],
    status: '连载中',
    description: '广告公司里两个死对头——创意总监姜允儿和客户经理朴志浩，每天在公司吵得不可开交。然而一次公司团建后，两人的关系发生了微妙的变化。办公室里的欢喜冤家，笑料百出的职场恋爱喜剧。',
    updateDate: '2026-08-04',
    views: 890000,
    rating: 9.1,
    chapters: [
      { num: 1, title: '第1话 冤家聚头', date: '2025-05-01' },
      { num: 2, title: '第2话 第一次合作', date: '2025-05-08' },
      { num: 3, title: '第3话 咖啡事件', date: '2025-05-15' },
      { num: 4, title: '第4话 公司团建', date: '2025-05-22' },
      { num: 5, title: '第5话 意外之吻', date: '2025-05-29' },
      { num: 6, title: '第6话 尴尬的周一', date: '2025-06-05' },
    ],
  },
  {
    id: '10',
    slug: 'ghost-doctor',
    title: '幽灵医生',
    author: '李贤民',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20medical%20cover%20style%20doctor%20in%20white%20coat%20with%20ghostly%20translucent%20figure%20behind%20him%20hospital%20background%20mysterious%20atmosphere%20cool%20tones%20digital%20art&width=600&height=800&seq=comic-10&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '医疗', '灵异'],
    status: '连载中',
    description: '天才外科医生车英民在一场车祸后获得了看到鬼魂的能力。他发现医院中徘徊着许多无法安息的灵魂，每一个都在诉说着不为人知的故事。车医生一边救治活人，一边帮助亡魂完成未了的心愿，揭开了一个又一个惊天秘密。',
    updateDate: '2026-08-01',
    views: 1120000,
    rating: 9.4,
    chapters: [
      { num: 1, title: '第1话 车祸', date: '2025-02-01' },
      { num: 2, title: '第2话 新能力', date: '2025-02-08' },
      { num: 3, title: '第3话 第一个鬼魂', date: '2025-02-15' },
      { num: 4, title: '第4话 未完成的手术', date: '2025-02-22' },
      { num: 5, title: '第5话 真相', date: '2025-03-01' },
      { num: 6, title: '第6话 连环事件', date: '2025-03-08' },
    ],
  },
  {
    id: '11',
    slug: 'daily-life-immortal',
    title: '修仙日常',
    author: '清风',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20cover%20style%20ancient%20Chinese%20style%20young%20cultivator%20eating%20noodles%20in%20a%20tavern%20funny%20expression%20bright%20and%20warm%20atmosphere%20clean%20white%20background%20digital%20art&width=600&height=800&seq=comic-11&orientation=portrait',
    category: 'comedy',
    tags: ['搞笑', '修仙', '日常'],
    status: '连载中',
    description: '穿越到修仙世界的现代宅男林小凡，本想着修成大道飞升成仙。但这里的修仙界也太卷了！打不过就加入？不不不，我先躺平吃个火锅。一个不走寻常路的修仙者，在危机四伏的修真世界里过着悠哉日常的搞笑故事。',
    updateDate: '2026-08-03',
    views: 760000,
    rating: 9.0,
    chapters: [
      { num: 1, title: '第1话 穿越', date: '2025-06-01' },
      { num: 2, title: '第2话 修真界太难了', date: '2025-06-08' },
      { num: 3, title: '第3话 躺平大法', date: '2025-06-15' },
      { num: 4, title: '第4话 火锅修仙', date: '2025-06-22' },
      { num: 5, title: '第5话 意外突破', date: '2025-06-29' },
    ],
  },
  {
    id: '12',
    slug: 'horror-school',
    title: '校园怪谈',
    author: 'DarkK',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%20style%20abandoned%20school%20corridor%20at%20night%20with%20mysterious%20shadow%20figure%20flickering%20lights%20creepy%20atmosphere%20cold%20blue%20tones%20dark%20background%20digital%20art&width=600&height=800&seq=comic-12&orientation=portrait',
    category: 'horror',
    tags: ['恐怖', '校园', '怪谈'],
    status: '已完结',
    description: '圣光高中流传着七大怪谈——音乐教室里自弹的钢琴、三楼女厕的哭泣声、午夜图书馆的脚步声……转学生苏敏雅不相信这些传闻，直到她亲眼目睹了不可思议的景象。每个怪谈背后，都隐藏着一段令人毛骨悚然的真相。',
    updateDate: '2026-07-25',
    views: 1450000,
    rating: 9.3,
    chapters: [
      { num: 1, title: '第1话 转校生', date: '2024-09-01' },
      { num: 2, title: '第2话 音乐教室', date: '2024-09-08' },
      { num: 3, title: '第3话 钢琴声', date: '2024-09-15' },
      { num: 4, title: '第4话 女厕', date: '2024-09-22' },
      { num: 5, title: '第5话 哭泣的女孩', date: '2024-09-29' },
      { num: 6, title: '第6话 图书馆', date: '2024-10-06' },
      { num: 7, title: '第7话 最终怪谈', date: '2024-10-13' },
      { num: 8, title: '第8话 真相', date: '2024-10-20' },
    ],
  },
];

export function getComicsByCategory(categorySlug: string) {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.category === categorySlug);
}

export function getComicBySlug(slug: string) {
  return comics.find((c) => c.slug === slug) || null;
}

export function getRelatedComics(currentSlug: string, category: string, limit: number = 4) {
  return comics
    .filter((c) => c.slug !== currentSlug && c.category === category)
    .slice(0, limit);
}

export function getLatestComics(limit: number = 8) {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
}

export function getPopularComics(limit: number = 8) {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}